import { render, staticRenderFns } from "./Authorizing.vue?vue&type=template&id=5927e96e&"
import script from "./Authorizing.vue?vue&type=script&lang=ts&"
export * from "./Authorizing.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports